import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { fetchAdminMe } from "@/lib/adminApi";

const RequireAdmin = ({ children }) => {
    const [status, setStatus] = useState("checking"); // 'checking' | 'ok' | 'anon'

    useEffect(() => {
        let cancelled = false;
        fetchAdminMe().then((admin) => {
            if (cancelled) return;
            setStatus(admin ? "ok" : "anon");
        });
        return () => {
            cancelled = true;
        };
    }, []);

    if (status === "checking") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-surface">
                <Loader2 className="animate-spin text-indigo_brand" size={26} />
            </div>
        );
    }
    if (status === "anon") {
        return <Navigate to="/admin/login" replace />;
    }
    return children;
};

export default RequireAdmin;
